export default "__VITE_ASSET__PvUkgFeo__"